import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._b({attrs:{"depressed":"","loading":_vm.loading,"small":"","color":"secondary"},on:{"click":_vm.unapproveHandler}},'v-btn',_vm.$attrs,false),[_c('div',{staticClass:"d-flex align-center flex-gap-8"},[_c('span',[_vm._v(_vm._s(_vm.$t('Unapprove')))]),(_vm.showAmount)?_c('span',[_vm._v("("+_vm._s(_vm.ids.length)+")")]):_vm._e(),_c(VIcon,[_vm._v("cancel")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }